import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CollectionsIcon from "@mui/icons-material/Collections";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import FestivalIcon from "@mui/icons-material/Festival";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import GroupsIcon from "@mui/icons-material/Groups";
import HomeIcon from "@mui/icons-material/Home";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import PaymentIcon from "@mui/icons-material/Payment";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import SettingsIcon from "@mui/icons-material/Settings";
import TodayIcon from "@mui/icons-material/Today";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import { DrawerOption } from "src/app/models/components/drawer.model";
const options: DrawerOption[] = [
  {
    displayName: "Dashboard",
    navigationPath: "/dashboard",
    icon: HomeIcon,
    acceptedRoles: ["Admin", "Parent", "Model", "Guest"],
    variation: "warpa",
  },
  {
    displayName: "Users",
    navigationPath: "/userManagement",
    icon: GroupsIcon,
    acceptedRoles: ["Admin", "Parent", "Model"],
    variation: "warpa",
  },
  {
    displayName: "Availability",
    navigationPath: "/availabilityCalendar",
    icon: EditCalendarIcon,
    acceptedRoles: ["Admin", "Parent", "Model"],
    variation: "warpa",
  },
  {
    displayName: "Requests",
    navigationPath: "/requestManagement",
    icon: PendingActionsIcon,
    acceptedRoles: ["Admin", "Parent", "Model", "Guest"],
    variation: "warpa",
  },
  {
    displayName: "My Calendar",
    navigationPath: "/calendar",
    icon: CalendarMonthIcon,
    acceptedRoles: ["Admin", "Parent", "Model", "Guest"],
    variation: "warpa",
  },
  {
    displayName: "Logs",
    navigationPath: "/logs",
    icon: WorkHistoryIcon,
    acceptedRoles: ["Admin", "Parent", "Model", "Guest"],
    variation: "warpa",
  },
  {
    displayName: "Settings",
    navigationPath: "/settings",
    icon: SettingsIcon,
    acceptedRoles: ["Admin", "Model", "Parent", "Guest"],
    variation: "warpa",
  },
  {
    displayName: "P.O.D Dashboard",
    navigationPath: "/podDashboard",
    icon: HomeIcon,
    acceptedRoles: ["Admin", "Model", "Parent", "Guest"],
    variation: "pod",
  },
  {
    displayName: "Tasks",
    navigationPath: "/tasks",
    icon: FormatListBulletedIcon,
    acceptedRoles: ["Admin", "Model", "Parent", "Guest"],
    variation: "pod",
  },
  {
    displayName: "Task Requests",
    navigationPath: "/taskRequests",
    icon: MoveToInboxIcon,
    acceptedRoles: ["Admin", "Model", "Parent", "Guest"],
    variation: "pod",
  },
  {
    displayName: "Schedule",
    navigationPath: "/schedule",
    icon: TodayIcon,
    acceptedRoles: ["Admin", "Model", "Parent", "Guest"],
    variation: "pod",
  },
  {
    displayName: "P.O.D Logs",
    navigationPath: "/podLogs",
    icon: WorkHistoryIcon,
    acceptedRoles: ["Admin", "Parent", "Model", "Guest"],
    variation: "pod",
  },
  {
    displayName: "Payments",
    navigationPath: "/payments",
    icon: PaymentIcon,
    acceptedRoles: ["Admin", "Parent", "Model"],
    variation: "pod",
  },
  {
    displayName: "Cloudie",
    navigationPath: "/cloudie",
    icon: CollectionsIcon,
    acceptedRoles: ["Admin", "Parent", "Model", "Guest"],
    variation: "pod",
  },
  {
    displayName: "Files",
    navigationPath: "/files",
    icon: CloudUploadIcon,
    acceptedRoles: ["Admin", "Parent", "Model", "Guest"],
    variation: "pod",
  },
  {
    displayName: "Events",
    navigationPath: "/events",
    icon: FestivalIcon,
    acceptedRoles: ["Admin", "Parent", "Model", "Guest"],
    variation: "pod",
  },
];

export default options;
